module.exports = $;


//////////////////
// WEBPACK FOOTER
// external "$"
// module id = 35
// module chunks = 0